import React from "react";
import { ShieldCheck, ShieldAlert, ShieldQuestion, Clock3 } from "lucide-react";
import { fmtDate } from "@/components/bp/bpLabels";

export const VIG_STYLE = {
  missing: { label: "À déposer", cls: "bg-[#E60000] text-white", Icon: ShieldAlert },
  pending: { label: "En vérification", cls: "bg-[#F59E0B] text-white", Icon: Clock3 },
  valid: { label: "Valide", cls: "bg-[#059669] text-white", Icon: ShieldCheck },
  expiring: { label: "Expire bientôt", cls: "bg-[#F59E0B] text-white", Icon: ShieldAlert },
  expired: { label: "Expirée", cls: "bg-[#E60000] text-white", Icon: ShieldAlert },
  rejected: { label: "Refusée", cls: "bg-[#E60000] text-white", Icon: ShieldQuestion },
};

export const VigBadge = ({ state, testid }) => { const s = VIG_STYLE[state] || VIG_STYLE.missing; return <span className={`inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.2em] font-bold px-1.5 py-0.5 ${s.cls}`} data-testid={testid}><s.Icon className="h-3 w-3" />{s.label}</span>; };

/** Phrase d'état lisible (profil BP, fiche admin). */
export const vigSentence = (v) => {
  if (!v) return "";
  if (v.state === "missing") return "Aucune attestation déposée — vos versements de commissions sont bloqués tant qu'une attestation valide n'est pas enregistrée.";
  if (v.state === "pending") return `Déposée le ${fmtDate(v.uploaded_at)} (délivrée le ${fmtDate(v.issued_at)}) — en cours de vérification par l'équipe PAG.`;
  if (v.state === "rejected") return `Refusée le ${fmtDate(v.reviewed_at)}${v.reject_reason ? ` : ${v.reject_reason}` : ""} — déposez un nouveau document.`;
  if (v.state === "expired") return `Expirée depuis le ${fmtDate(v.expires_at)} — déposez une nouvelle attestation pour débloquer vos versements.`;
  if (v.state === "expiring") return `Valide jusqu'au ${fmtDate(v.expires_at)} (dans ${v.days_left} jour${v.days_left > 1 ? "s" : ""}) — pensez à la renouveler.`;
  return `Valide jusqu'au ${fmtDate(v.expires_at)} (${v.days_left} jours restants).`;
};
